export const post = (path, data, callback) => {
  const url = `${process.env.API_URL}${path}`

  // Use XHR to support IE10+
  const xhr = new XMLHttpRequest()
  xhr.open('POST', url, true)
  xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8')
  xhr.onreadystatechange = () => {
    if (xhr.readyState == XMLHttpRequest.DONE) {
      callback(JSON.parse(xhr.response))
    }
  }
  xhr.onerror = e => {
    window.alert(e)
    console.error(e)
  }
  xhr.send(JSON.stringify(data))

  /*
  return fetch(url, {
    method: 'POST',
    mode: 'cors', // no-cors, cors, *same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, same-origin, *omit
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(data),
  })
    .then(response => response.json())
    .catch(error => console.error(`Fetch Error\n`, error))
  */
}



// WEBPACK FOOTER //
// ./src/lib/api/index.js